/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
import Tab from '../../component/Inc/Tab';
const sampleImg = 'https://via.placeholder.com/400x450';
function Popup() {
  const [modalAlert, setModalAlert] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '노출중', value: 1},
    {title: '미노출', value: 2}
  ];
  return (
    <main className="com_container p_manage_popup">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_9">팝업 관리</h2>
          <div className="com_btn_wrap">
            <button onClick={() => {}} className="com_btn orange s btn_plus">
              팝업 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <table className="com_board_list type_row">
              <colgroup>
                <col width="15%" />
                <col width="35%" />
                <col width="15%" />
                <col width="35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>등록일</th>
                  <td className="td_left">2023.01.10</td>
                  <th>팝업 이미지 / 크기</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <div className="com_input_upload">
                        <Upload title="이미지 등록" className="com_btn gray xs wl" />
                        <p className="file">
                          <span className="txt">File name.pdf</span>
                          <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        </p>
                      </div>
                      <input type="text" className="input s" placeholder="W:50" />
                      <input type="text" className="input s" placeholder="H:50" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>등록자</th>
                  <td className="td_left">홍등록103</td>
                  <th>팝업경로</th>
                  <td className="td_left">
                    <input type="text" className="input" placeholder="URL을 복사해서 넣으세요." />
                  </td>
                </tr>
                <tr>
                  <th>팝업명</th>
                  <td className="td_left">
                    <input type="text" className="input" defaultValue={`생일축하 팝업입니다.`} />
                  </td>
                  <th>노출기간</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">무제한</label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">기간</label>
                      </div>
                      <div className="date_wrap">
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        <span className="divider"> ~ </span>
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <button className="com_btn orange xs">등록</button>
            </div>
            <div className="com_board_list__bottom">
              <div className="com_btn_wrap">
                <button
                  className="com_btn black xs btn_preview"
                  onClick={() => {
                    setModalAlert(true);
                  }}
                >
                  팝업 미리보기
                </button>
              </div>
            </div>
          </section>
          <section className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="팝업위치">팝업위치</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="3%" />
                <col width="8%" />
                <col width="7%" />
                <col width="7%" />
                <col width="8%" />
                <col width="9%" />
                <col width="3%" />
                <col width="3%" />
                <col width="14%" />
                <col width="8%" />
                <col width="4%" />
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>팝업 위치</th>
                  <th>팝업명</th>
                  <th>팝업 이미지</th>
                  <th>W</th>
                  <th>H</th>
                  <th>팝업 경로</th>
                  <th>노출 기간</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="td_date">2023.6.5</td>
                      <td>
                        <button className="btn_link">홍들공103</button>
                      </td>
                      <td>학생관리</td>
                      <td>이벤트 팝업</td>
                      <td>이미지명이미지명</td>
                      <td>459</td>
                      <td>450</td>
                      <td>http://com.ezro.kr/a_home/main/</td>
                      <td className="td_date">2023.6.5 ~ 2023.6.10</td>
                      <td className="td_point">노출</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>11</td>
                  <td className="td_date">2023.6.5</td>
                  <td>
                    <button className="btn_link">홍들공103</button>
                  </td>
                  <td>학생관리</td>
                  <td>이벤트 팝업</td>
                  <td>이미지명이미지명</td>
                  <td>459</td>
                  <td>450</td>
                  <td>http://com.ezro.kr/a_home/main/</td>
                  <td className="td_date">2023.6.5 ~ 2023.6.10</td>
                  <td className="td_red">미노출</td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_image">
        <div className="content_container mb_no">
          <img src={sampleImg} alt="영수증 이미지" />
        </div>
        <div className="btn_container">
          <div className="check">
            <input type="checkbox" name="chk" id="chk_1" className="com_chk" />
            <label htmlFor="chk_1">오늘하루 보지 않기</label>
          </div>
          <button
            className="btn_pop_close"
            onClick={() => {
              setModalAlert(false);
            }}
          >
            창닫기 X
          </button>
        </div>
      </Modal>
    </main>
  );
}

export default Popup;
